const translations = {
  // Navigation
  "nav.home": "Accueil",
  "nav.about": "À Propos",
  "nav.services": "Services",
  "nav.calendar": "Calendrier",
  "nav.sermons": "Sermons",
  "nav.resources": "Ressources",
  "nav.news": "Actualités",
  "nav.contact": "Contact",
  "nav.donate": "Faire un Don",

  // Hero Section
  "hero.title": "Saint Mina & Pape Cyrille VI",
  "hero.subtitle": "Église Copte Orthodoxe",
  "hero.tagline": "Enracinés dans une foi ancienne dans un monde moderne",
  "hero.location": "Au service de la Rive-Nord de Montréal",
  "hero.joinUs": "Rejoignez-nous ce Dimanche",
  "hero.learnMore": "En Savoir Plus",

  // Liturgy Schedule
  "liturgy.sunday": "Dimanche",
  "liturgy.wednesday": "Mercredi",
  "liturgy.friday": "Vendredi",
  "liturgy.saturday": "Samedi",
  "liturgy.satVespers": "Vêpres Sam.",
  "liturgy.weeklySchedule": "Horaire Hebdomadaire",
  "liturgy.divineLiturgyTimes": "Horaires de la Divine Liturgie",
  "liturgy.joinEucharist": "Rejoignez-nous pour la Sainte Eucharistie tout au long de la semaine",
  "liturgy.divineLiturgy": "Divine Liturgie",
  "liturgy.saturdayEvening": "Samedi Soir",
  "liturgy.vespersMidnight": "Vêpres & Louanges de Minuit (Tasbeha)",
  "liturgy.viewFullCalendar": "Voir le Calendrier Complet",
  "liturgy.thisWeekLiturgies": "Liturgies de Cette Semaine",
  "liturgy.thisWeekSchedule": "Horaire de Cette Semaine",
  "liturgy.liveFromGoogleCalendar": "En direct de Google Calendar",
  "liturgy.loadingSchedule": "Chargement de l'horaire liturgique…",
  "liturgy.time": "Heure",
  "liturgy.language": "Langue",
  "liturgy.location": "Lieu",
  "liturgy.divineService": "Service Divin",

  // Services Section
  "services.title": "Nos Services",
  "services.subtitle": "Rejoignez-nous pour le culte, la croissance spirituelle et la communion fraternelle",
  "services.confession": "Confession",
  "services.confessionDesc": "Guidance spirituelle et réconciliation",
  "services.sundaySchool": "École du Dimanche",
  "services.sundaySchoolDesc": "Éducation à la foi pour tous les âges",
  "services.preschoolCoptic": "Copte Préscolaire",
  "services.preschoolCopticDesc": "Enseignement de notre langue sacrée",
  "services.holyLiturgy": "Sainte Liturgie",
  "services.holyLiturgyTime": "Dimanche 8h00 – 11h30",
  "services.choir": "Chorale",
  "services.choirDesc": "Hymnes et mélodies sacrées",
  "services.bibleStudy": "Étude Biblique",
  "services.bibleStudyDesc": "Approfondissez votre foi par les Écritures",
  "services.viewFullSchedule": "Voir l'Horaire Complet",

  // Church Leaders
  "leaders.title": "Notre Église Copte Orthodoxe",
  "leaders.subtitle": "Dirigée par des serviteurs fidèles dévoués à la guidance spirituelle",
  "leaders.popeTawadros": "Sa Sainteté le Pape Tawadros II",
  "leaders.popeTawadrosTitle": "118e Pape d'Alexandrie et Patriarche du Siège de Saint Marc",
  "leaders.popeTawadrosDesc": "Sa Sainteté dirige l'Église Copte Orthodoxe dans le monde entier avec sagesse et dévotion, poursuivant la succession apostolique de Saint Marc.",
  "leaders.bishopBoulos": "Sa Grâce l'Évêque Boulos",
  "leaders.bishopBoulosTitle": "Évêque du diocèse d'Ottawa, Montréal et l'Est du Canada",
  "leaders.bishopBoulosDesc": "Sa Grâce sert avec dévouement et amour, offrant guidance spirituelle et soins pastoraux à notre communauté.",
  "leaders.fatherAnthony": "Père Anthony Micheal",
  "leaders.fatherAnthonyTitle": "Prêtre à l'Église Copte Orthodoxe Saint Mina et Pape Cyrille VI",
  "leaders.fatherAnthonyDesc": "Le Père Anthony sert notre paroisse avec compassion et dévouement, guidant notre communauté dans la foi et l'amour.",

  // Featured Sections
  "featured.recentSermons": "Sermons Récents",
  "featured.sermonsDesc": "Écoutez les messages inspirants de notre clergé",
  "featured.viewAllSermons": "Voir Tous les Sermons",
  "featured.upcomingEvents": "Événements à Venir",
  "featured.eventsDesc": "Rejoignez-nous pour la communion fraternelle et les activités communautaires",
  "featured.viewAllEvents": "Voir Tous les Événements",
  "featured.photoGallery": "Galerie Photos",
  "featured.galleryDesc": "Icônes sacrées et moments communautaires",
  "featured.viewGallery": "Voir la Galerie",

  // CTA Section
  "cta.supportMission": "Soutenez Notre Mission",
  "cta.supportDesc": "Vos généreuses contributions nous aident à poursuivre notre ministère et à servir notre communauté",
  "cta.makeDonation": "Faire un Don",

  // Footer
  "footer.quickLinks": "Liens Rapides",
  "footer.contact": "Contact",
  "footer.followUs": "Suivez-nous",
  "footer.rights": "Tous droits réservés.",
  "footer.tagline": "Enracinés dans l'antique foi orthodoxe\u00a0Au service de la Rive-Nord de Montréal.",
  "footer.church": "Église",
  "footer.resources": "Ressources",
  "footer.connect": "Connexion",
  "footer.resourcesHub": "Centre de Ressources",
  "footer.baptismForm": "Demande de Baptême",
  "footer.marriageForm": "Demande de Mariage",
  "footer.funeralForm": "Demande de Funérailles",
  "footer.eventBooking": "Réservation d'Événement",
  "footer.membershipForm": "Adhésion",
  "footer.engagementForm": "Demande de Fiançailles",
  "footer.privacyPolicy": "Politique de Confidentialité",
  "footer.termsOfService": "Conditions d'Utilisation",
  "footer.copyright": "© 2026 Église Copte Orthodoxe Saint Mina & Pape Cyrille VI. Tous droits réservés.",

  // ── Home Page ──
  "home.seasonalPosts": "Articles Saisonniers",
  "home.seasonalPostsDesc": "Réflexions approfondies sur les saisons et célébrations de l'année liturgique copte orthodoxe",
  "home.currentlyObserving": "Observance Actuelle",
  "home.daysRemaining": "jours restants",
  "home.dayRemaining": "jour restant",
  "home.nextFeast": "Prochaine Fête",
  "home.daysAway": "jours avant",
  "home.dayAway": "jour avant",
  "home.fastingSeason": "Saison de Jeûne",
  "home.holyWeek": "Semaine Sainte",
  "home.upcomingFeast": "Fête à Venir",
  "home.currentSeason": "Saison Actuelle",
  "home.liturgicalSeason": "Saison Liturgique",
  "home.readFullArticle": "Lire l'Article Complet",
  "home.viewAllNews": "Voir Toutes les Actualités",
  "home.divineService": "Service Divin",
  "home.time": "Heure",
  "home.language": "Langue",
  "home.location": "Lieu",
  "home.viewFullCalendar": "Voir le Calendrier Complet",
  "home.liveFromGoogleCalendar": "En direct de Google Calendar",
  "home.loadingLiturgySchedule": "Chargement de l'horaire liturgique…",
  "home.thisWeekLiturgies": "Liturgies de Cette Semaine",
  "home.thisWeekSchedule": "Horaire de Cette Semaine",
  "home.close": "Fermer",
  "home.openOnYouTube": "Ouvrir sur YouTube",
  "home.stayConnected": "Restez Connectés",
  "home.followUsSocial": "Suivez-nous sur les Réseaux Sociaux",
  "home.socialDesc": "Restez connectés avec nos derniers moments, réflexions et moments forts de la communauté sur toutes nos plateformes.",
  "home.spiritualGuidance": "Guidance Spirituelle",
  "home.liveStreaming": "Diffusion en Direct",
  "home.sermonsDesc": "Écoutez les messages inspirants et les enseignements de notre clergé",
  "home.latest": "Récent",
  "home.viewAllOnYouTube": "Voir Tout sur YouTube",
  "home.noSermonsAvailable": "Aucun sermon disponible pour le moment.",
  "home.ourChurch": "Notre Église Copte Orthodoxe",
  "home.churchLeadersDesc": "Dirigée par des serviteurs fidèles dédiés à la guidance spirituelle",
  "home.learnMoreAboutUs": "En Savoir Plus Sur Nous",
  "home.subscribeNewsletter": "Abonnez-vous à notre bulletin pour des mises à jour sur les services, événements et réflexions spirituelles",
  "home.stayConnectedNewsletter": "Restez Connectés",
  "home.monthlyNewsletter": "Bulletin Mensuel",
  "home.viewAllNewsletters": "Voir Tous les Bulletins",
  "home.firstName": "Prénom",
  "home.emailAddress": "Adresse Courriel",
  "home.subscribeBtn": "S'abonner au Bulletin",
  "home.subscribing": "Abonnement en cours...",
  "home.subscribeSuccess": "Merci de vous être abonné! Vous recevrez nos mises à jour bientôt.",
  "home.subscribeError": "Une erreur s'est produite. Veuillez réessayer.",
  "home.privacyNote": "Nous respectons votre vie privée. Désabonnez-vous à tout moment.",
  "home.ourServices": "Nos Services",
  "home.servicesDesc": "Découvrez comment notre église vous sert par le culte, l'enseignement et les soins communautaires",
  "home.exploreServices": "Explorer Nos Services",
  "home.moreComingSoon": "Plus à venir bientôt",
  "home.yourGenerosity": "Votre Générosité Fait la Différence",
  "home.supportMission": "Soutenez Notre",
  "home.mission": "Mission",
  "home.donateDesc": "Vos généreuses contributions nous aident à poursuivre notre ministère, soutenir les programmes communautaires et répandre l'amour de Dieu.",
  "home.taxDeductible": "Tous les dons sont déductibles d'impôt et traités de manière sécurisée",
  "home.giveNow": "Donner Maintenant",
  "home.recurringGift": "Configurer un Don Récurrent",
  "home.securePayment": "Paiement Sécurisé",
  "home.sslEncrypted": "Cryptage SSL",
  "home.taxReceipt": "Reçu Fiscal Fourni",
  "home.ministryPrograms": "Programmes Ministériels",
  "home.ministryProgramsDesc": "Soutenir les services de culte, les programmes jeunesse et les initiatives de croissance spirituelle",
  "home.communityOutreach": "Action Communautaire",
  "home.communityOutreachDesc": "Aider les personnes dans le besoin via les banques alimentaires, refuges et services de soutien",
  "home.missionWork": "Travail Missionnaire",
  "home.missionWorkDesc": "Répandre l'évangile et servir les communautés à travers le monde",
  "home.ancientFaith": "Foi Ancienne",
  "home.copticTradition": "Tradition Copte",
  "home.montreal": "Montréal",
  "home.copticHeritage": "Notre Patrimoine Copte",
  "home.years2000": "2000+ Ans",
  "home.apostolicChurch": "Église Apostolique",
  "home.livingTradition": "Tradition Vivante",
  "home.symbolOfFaith": "Symbole de notre foi",
  "home.copticCross": "La Croix Copte",
  "home.sacredTraditions": "Nos Traditions Sacrées",
  "home.divineLiturgy": "Divine Liturgie",
  "home.divineLiturgyDesc": "Notre liturgie, composée par Saint Basile et Saint Grégoire, est célébrée sans changement depuis des siècles. La Divine Liturgie est le cœur du culte copte.",
  "home.copticHymns": "Hymnes Coptes",
  "home.copticHymnsDesc": "Notre tradition musicale unique préserve des mélodies de l'ancienne musique des temples égyptiens. Ces hymnes sacrés créent une atmosphère profondément spirituelle.",
  "home.fastingFeasts": "Jeûnes et Fêtes",
  "home.fastingFeastsDesc": "L'Église Copte observe plus de 210 jours de jeûne par an. Notre calendrier est riche en fêtes célébrant la Vierge Marie, les saints et les événements du salut.",
  "home.iconography": "Iconographie",
  "home.iconographyDesc": "Les icônes coptes sont des fenêtres vers le ciel, représentant le Christ et les saints dans le style byzantin-égyptien distinctif.",
  "home.monasticism": "Monachisme",
  "home.monasticismDesc": "L'Égypte est le berceau du monachisme chrétien. Les saints Antoine et Pacôme ont établi la tradition monastique qui inspire notre vie spirituelle.",
  "home.copticLanguage": "Langue Copte",
  "home.copticLanguageDesc": "La langue copte, dernière étape de l'ancien égyptien, est préservée dans notre liturgie. Elle nous relie à la langue parlée en Égypte au temps du Christ.",
  "home.loveCompassion": "Amour et Compassion",
  "home.loveCompassionDesc": "Suivant le commandement du Christ de nous aimer les uns les autres, nous montrons l'amour de Dieu par des actes de bonté et de compassion.",
  "home.community": "Communauté",
  "home.communityDesc": "Construire des relations significatives enracinées dans la foi, dans un environnement chaleureux et accueillant qui honore notre patrimoine copte.",
  "home.service": "Service",
  "home.serviceDesc": "Avoir un impact positif grâce aux programmes de sensibilisation et au service des personnes dans le besoin, suivant l'exemple de nos saints patrons.",
  "home.upcoming": "À Venir",
  "home.joinFellowship": "Rejoignez-nous en Communion Fraternelle",
  "home.learnMore": "En Savoir Plus",
  "home.getInTouch": "Entrer en Contact",
  "home.address": "Adresse",
  "home.phone": "Téléphone",
  "home.email": "Courriel",
  "home.officeHours": "Heures de Bureau",
  "home.officeHoursValue": "Lundi - Vendredi: 9h00 - 17h00\nSamedi: 10h00 - 14h00",
  "home.sendMessage": "Envoyer le Message",
  "home.sending": "Envoi en cours...",
  "home.thankYou": "Merci! Nous vous répondrons bientôt.",
  "home.namePlaceholder": "Votre nom complet",
  "home.emailPlaceholder": "votre.courriel@exemple.com",
  "home.phonePlaceholder": "(555) 123-4567",
  "home.messagePlaceholder": "Comment pouvons-nous vous aider?",
  "home.message": "Message",
  "home.newsletter.january": "Bulletin de Janvier",
  "home.newsletter.december": "Bulletin de Décembre",
  "home.newsletter.november": "Bulletin de Novembre",
  "home.newsletter.october": "Bulletin d'Octobre",
  "home.newsletter.janDesc": "Bénédictions du nouvel an, événements à venir et mises à jour",
  "home.newsletter.decDesc": "Célébrations de Noël, bilan de l'année et gratitude",
  "home.newsletter.novDesc": "Réflexions d'action de grâce et moments forts",
  "home.newsletter.octDesc": "Activités d'automne et opportunités de ministère",
  "home.newsletter.janDate": "Janvier 2025",
  "home.newsletter.decDate": "Décembre 2024",
  "home.newsletter.novDate": "Novembre 2024",
  "home.newsletter.octDate": "Octobre 2024",

  // ── Home Events Component ──
  "home.events.upcoming": "À Venir",
  "home.events.communityOutreach": "Journée d'Action Communautaire",
  "home.events.communityOutreachDesc": "Rejoignez-nous pour servir notre communauté locale avec la distribution de nourriture et des services de soutien.",
  "home.events.youthGathering": "Rassemblement du Groupe Jeunesse",
  "home.events.youthGatheringDesc": "Activités amusantes, culte et communion fraternelle pour les ados et jeunes adultes.",
  "home.events.marriageWorkshop": "Atelier d'Enrichissement du Mariage",
  "home.events.marriageWorkshopDesc": "Renforcez votre relation avec des outils pratiques et la sagesse biblique.",
  "home.events.movieNight": "Soirée Cinéma en Famille",
  "home.events.movieNightDesc": "Amenez toute la famille pour une soirée amusante avec du popcorn et de la communion fraternelle.",
  "home.events.learnMore": "En Savoir Plus →",

  // ── Home CopticCalendar Component ──
  "home.calendar.liturgicalSchedule": "Horaire Liturgique",
  "home.calendar.thisWeek": "Cette Semaine à Notre Église",
  "home.calendar.thisWeekDesc": "Restez connectés avec nos services hebdomadaires, jours de fête et rassemblements communautaires",
  "home.calendar.sundayLiturgy": "Liturgie du Dimanche",
  "home.calendar.sundayLiturgyDesc": "Divine Liturgie chaque dimanche de 8h00 à 11h30 avec des hymnes en anglais et en arabe.",
  "home.calendar.saturdayVespers": "Vêpres du Samedi",
  "home.calendar.saturdayVespersDesc": "Prières du soir et Tasbeha (Louanges de Minuit) chaque samedi soir.",
  "home.calendar.bibleStudy": "Étude Biblique",
  "home.calendar.bibleStudyDesc": "Étude biblique hebdomadaire et discussions spirituelles chaque mercredi soir.",
  "home.calendar.viewFullCalendar": "Voir le Calendrier Complet et les Jours de Fête",

  // ── Home AboutUs Component ──
  "home.about.copticHeritage": "Notre Patrimoine Copte",
  "home.about.ancientFaith": "Foi Ancienne",
  "home.about.copticTradition": "Tradition Copte",
  "home.about.montreal": "Montréal",
  "home.about.years2000": "2000+ Ans",
  "home.about.apostolicChurch": "Église Apostolique",
  "home.about.livingTradition": "Tradition Vivante",
  "home.about.heritageIntro1": "L'Église Copte Orthodoxe fait remonter ses racines à Saint Marc l'Apôtre, qui a apporté le christianisme en Égypte au premier siècle. Depuis plus de 2000 ans, notre Église a préservé l'ancienne foi apostolique, maintenant des traditions ininterrompues de culte, de liturgie et de pratique spirituelle.",
  "home.about.heritageIntro2": "Notre église porte le nom de deux piliers de la spiritualité copte : Saint Mina, le martyr miraculeux et protecteur, et le Pape Cyrille VI, le saint moderne connu pour sa sainteté et ses miracles. Nous apportons ce riche héritage sur la Rive-Nord de Montréal.",
  "home.about.sacredTraditions": "Nos Traditions Sacrées",
  "home.about.divineLiturgy": "Divine Liturgie",
  "home.about.divineLiturgyDesc": "Notre liturgie, composée par Saint Basile et Saint Grégoire, est célébrée sans changement depuis des siècles. La Divine Liturgie est le cœur du culte copte.",
  "home.about.copticHymns": "Hymnes Coptes",
  "home.about.copticHymnsDesc": "Notre tradition musicale unique préserve des mélodies de l'ancienne musique des temples égyptiens. Ces hymnes sacrés créent une atmosphère profondément spirituelle.",
  "home.about.fastingFeasts": "Jeûnes et Fêtes",
  "home.about.fastingFeastsDesc": "L'Église Copte observe plus de 210 jours de jeûne par an. Notre calendrier est riche en fêtes célébrant la Vierge Marie, les saints et les événements du salut.",
  "home.about.iconography": "Iconographie",
  "home.about.iconographyDesc": "Les icônes coptes sont des fenêtres vers le ciel, représentant le Christ et les saints dans le style byzantin-égyptien distinctif.",
  "home.about.monasticism": "Monachisme",
  "home.about.monasticismDesc": "L'Égypte est le berceau du monachisme chrétien. Les saints Antoine et Pacôme ont établi la tradition monastique qui inspire notre vie spirituelle.",
  "home.about.copticLanguage": "Langue Copte",
  "home.about.copticLanguageDesc": "La langue copte, dernière étape de l'ancien égyptien, est préservée dans notre liturgie. Elle nous relie à la langue parlée en Égypte au temps du Christ.",
  "home.about.loveCompassion": "Amour et Compassion",
  "home.about.loveCompassionDesc": "Suivant le commandement du Christ de nous aimer les uns les autres, nous montrons l'amour de Dieu par des actes de bonté et de compassion.",
  "home.about.community": "Communauté",
  "home.about.communityDesc": "Construire des relations significatives enracinées dans la foi, dans un environnement chaleureux et accueillant qui honore notre patrimoine copte.",
  "home.about.service": "Service",
  "home.about.serviceDesc": "Avoir un impact positif grâce aux programmes de sensibilisation et au service des personnes dans le besoin.",

  // ── Home Contact Component ──
  "home.contact.getInTouch": "Entrer en Contact",
  "home.contact.address": "Adresse",
  "home.contact.addressValue": "123 Avenue de la Foi\nSpringfield, IL 62701",
  "home.contact.phone": "Téléphone",
  "home.contact.phoneValue": "(555) 123-4567",
  "home.contact.email": "Courriel",
  "home.contact.emailValue": "contact@smpcvi.ca",
  "home.contact.officeHours": "Heures de Bureau",
  "home.contact.officeHoursValue": "Lundi - Vendredi: 9h00 - 17h00\nSamedi: 10h00 - 14h00",
  "home.contact.name": "Nom",
  "home.contact.namePlaceholder": "Votre nom complet",
  "home.contact.emailPlaceholder": "votre.courriel@exemple.com",
  "home.contact.phonePlaceholder": "(555) 123-4567",
  "home.contact.message": "Message",
  "home.contact.messagePlaceholder": "Comment pouvons-nous vous aider?",
  "home.contact.sendMessage": "Envoyer le Message",
  "home.contact.sending": "Envoi en cours...",
  "home.contact.thankYou": "Merci! Nous vous répondrons bientôt.",
  "home.contact.privacyNote": "Nous respectons votre vie privée et ne partagerons jamais vos informations.",

  // ── About Page ──
  "aboutPage.title": "À Propos de Nous",
  "aboutPage.subtitle": "Découvrez notre église, notre histoire et notre foi",
  "aboutPage.ourMission": "Notre Mission",
  "aboutPage.servingNorthShore": "Au service de la Rive-Nord de Montréal",
  "aboutPage.servingNorthShoreDesc1": "L'Église Copte Orthodoxe Saint Mina et Pape Cyrille VI a été établie avec une mission divine : servir les besoins spirituels des chrétiens orthodoxes vivant sur la Rive-Nord de Montréal. Notre église est un foyer spirituel pour les familles de Laval, Sainte-Thérèse, Blainville, Rosemère, Boisbriand, Mirabel et toutes les communautés environnantes.",
  "aboutPage.servingNorthShoreDesc2": "Avec la bénédiction de Sa Sainteté le Pape Tawadros II, nous apportons l'antique foi copte orthodoxe dans cette région, offrant la Sainte Liturgie, les sacrements, la guidance spirituelle et une communauté aimante pour tous ceux qui cherchent le Christ.",
  "aboutPage.strategicLocation": "Emplacement Stratégique",
  "aboutPage.strategicLocationDesc": "Situé au centre de Sainte-Thérèse pour desservir toute la Rive-Nord",
  "aboutPage.growingCommunity": "Communauté Grandissante",
  "aboutPage.growingCommunityDesc": "Accueillant des familles de Laval, Blainville, Mirabel et au-delà",
  "aboutPage.ourServiceArea": "Notre Zone de Service",
  "aboutPage.serviceAreaList": "Laval • Sainte-Thérèse • Blainville • Rosemère • Boisbriand • Mirabel • Terrebonne • et plus",
  "aboutPage.ourJourney": "Notre Parcours",
  "aboutPage.churchTimeline": "Chronologie de l'Église",
  "aboutPage.timelineDesc": "Fondée en 2016 avec la bénédiction de Sa Sainteté le Pape Tawadros II, notre église est passée d'une petite communauté à un foyer spirituel florissant.",
  "aboutPage.viewTimeline": "Voir Notre Chronologie",
  "aboutPage.hideTimeline": "Masquer la Chronologie",
  "aboutPage.collapseTimeline": "Réduire la Chronologie",
  "aboutPage.yearsOfFaith": "2 000 Ans de Foi",
  "aboutPage.copticChurchTitle": "L'Église Copte Orthodoxe",
  "aboutPage.copticChurchDesc": "L'une des plus anciennes églises chrétiennes au monde, fondée par Saint Marc l'Évangéliste à Alexandrie, en Égypte",
  "aboutPage.churchFounded": "Église Fondée",
  "aboutPage.faithfulWorldwide": "Fidèles dans le Monde",
  "aboutPage.popesOfAlexandria": "Papes d'Alexandrie",
  "aboutPage.fastingDays": "Jours de Jeûne/An",
  "aboutPage.heavenlyIntercessors": "Intercesseurs Célestes",
  "aboutPage.patronSaints": "Nos Saints Patrons",
  "aboutPage.patronSaintsDesc": "Les saints qui guident et intercèdent pour notre communauté ecclésiale",
  "aboutPage.spiritualGuidance": "Guidance Spirituelle",
  "aboutPage.spiritualFathers": "Nos Pères Spirituels",
  "aboutPage.spiritualFathersDesc": "Le Pape, l'Évêque et le Prêtre qui guident notre communauté dans la foi",
  "aboutPage.churchBoard": "Membres du Conseil d'Église",
  "aboutPage.churchBoardDesc": "Serviteurs dévoués dirigeant l'administration de notre paroisse",
  "aboutPage.ourMissionTitle": "Notre Mission",
  "aboutPage.ourMissionDesc": "Proclamer l'Évangile de Jésus-Christ, préserver la foi apostolique et les traditions coptes, et servir les besoins spirituels des chrétiens orthodoxes de la Rive-Nord de Montréal.",
  "aboutPage.ourVision": "Notre Vision",
  "aboutPage.ourVisionDesc": "Être un phare de la foi chrétienne orthodoxe sur la Rive-Nord, une paroisse vibrante qui nourrit la croissance spirituelle et accueille tous les chercheurs du Christ.",
  "aboutPage.missionCelebrate": "Célébrer la Sainte Liturgie et les Sacrements",
  "aboutPage.missionTeach": "Enseigner et préserver les traditions coptes orthodoxes",
  "aboutPage.missionCommunity": "Bâtir une communauté aimante et solidaire",
  "aboutPage.visionExpand": "Agrandir nos installations pour servir plus de familles",
  "aboutPage.visionYouth": "Développer les ministères jeunesse et famille",
  "aboutPage.visionOutreach": "Renforcer les programmes d'action communautaire",
  "aboutPage.joinFamily": "Rejoignez Notre Famille d'Église",
  "aboutPage.joinFamilyDesc": "Nous vous invitons à adorer avec nous et à faire partie de notre communauté grandissante",
  "aboutPage.viewServiceTimes": "Voir les Horaires des Services",

  // ── About Page Timeline Events ──
  "aboutPage.timeline.2016.title": "Le Commencement",
  "aboutPage.timeline.2016.desc": "La communauté a commencé à s'étendre sur la Rive-Nord de Montréal, à la demande du Pape Tawadros II. Il a envoyé le Père Anthony pour démarrer l'église sous Saint Mina et le Pape Cyrille VI. Moins d'un mois après la demande du Pape, nous avons trouvé une église à vendre et avons pu l'acheter. La première liturgie a été célébrée en novembre.",
  "aboutPage.timeline.2017.title": "Début des Rénovations",
  "aboutPage.timeline.2017.desc": "Les rénovations ont commencé au sous-sol et dans l'église à l'étage, transformant le bâtiment en un beau lieu de culte pour notre communauté grandissante.",
  "aboutPage.timeline.2018.title": "10e Anniversaire du Père Anthony",
  "aboutPage.timeline.2018.desc": "Nous avons célébré le 10e anniversaire du Père Anthony en tant que prêtre, honorant son service dévoué à l'Église Copte Orthodoxe.",
  "aboutPage.timeline.2019.title": "Ordination de l'Évêque Boulos",
  "aboutPage.timeline.2019.desc": "Le Pape Tawadros II a ordonné le Père Boulos el Baramousy comme Évêque Boulos pour le Diocèse d'Ottawa, Montréal et l'Est du Canada.",
  "aboutPage.timeline.2024.title": "Projet d'Iconostase",
  "aboutPage.timeline.2024.desc": "Le projet a commencé pour l'iconostase de l'église, un écran sacré orné d'icônes qui rehaussera notre culte liturgique.",
  "aboutPage.timeline.2025.title": "Rénovation Extérieure",
  "aboutPage.timeline.2025.desc": "Nous avons commencé la rénovation extérieure de l'église, embellissant l'extérieur pour refléter la gloire de Dieu.",
  "aboutPage.timeline.2026.title": "Célébration du 10e Anniversaire",
  "aboutPage.timeline.2026.desc": "Nous célébrons le 10e anniversaire de notre église, une décennie de foi, de croissance et de service à la communauté de la Rive-Nord.",

  // ── About Page Coptic History ──
  "aboutPage.copticHistory.origins.title": "Le Nom \"Égypte\" et le Patrimoine Copte",
  "aboutPage.copticHistory.origins.era": "Origines",
  "aboutPage.copticHistory.origins.desc": "Le mot \"Copte\" vient du grec \"Aigyptos\", qui dérive de \"Ha-Ka-Ptah\" (Maison de l'Esprit de Ptah), l'ancien nom de Memphis. Les Coptes sont les chrétiens indigènes d'Égypte.",
  "aboutPage.copticHistory.stMark.title": "Saint Marc l'Évangéliste",
  "aboutPage.copticHistory.stMark.desc": "Saint Marc, auteur du deuxième Évangile, a apporté le christianisme en Égypte vers 42 ap. J.-C. Il a établi l'Église d'Alexandrie et a fondé la célèbre École Catéchétique.",
  "aboutPage.copticHistory.councils.title": "Conciles Œcuméniques et Théologie",
  "aboutPage.copticHistory.councils.era": "Conciles",
  "aboutPage.copticHistory.councils.desc": "Les théologiens coptes ont joué des rôles cruciaux dans les premiers conciles. À Nicée (325), Saint Athanase a défendu la divinité du Christ. À Éphèse (431), Saint Cyrille a défendu Marie comme Théotokos.",
  "aboutPage.copticHistory.beliefs.title": "Ce Que Nous Croyons",
  "aboutPage.copticHistory.beliefs.era": "Croyances",
  "aboutPage.copticHistory.beliefs.desc": "Nous croyons en un seul Dieu : Père, Fils et Saint-Esprit. Nous confessons que Jésus-Christ est pleinement Dieu et pleinement homme, uni en une seule nature (Miaphysite).",
  "aboutPage.copticHistory.traditions.title": "Ce Qui Nous Rend Spéciaux",
  "aboutPage.copticHistory.traditions.era": "Traditions",
  "aboutPage.copticHistory.traditions.desc": "L'Église Copte préserve la langue copte dans la liturgie. Nous sommes le berceau du monachisme chrétien. Notre liturgie et nos traditions de jeûne restent inchangées depuis près de 2000 ans.",
  "aboutPage.copticHistory.today.title": "Une Foi Ancienne Vivante",
  "aboutPage.copticHistory.today.era": "Aujourd'hui",
  "aboutPage.copticHistory.today.desc": "Aujourd'hui, plus de 20 millions de Coptes dans le monde perpétuent cette foi apostolique. De l'Égypte à Montréal, nous maintenons la même liturgie établie par Saint Marc.",

  // About Page Saints
  "aboutPage.saints.stMina.name": "Saint Mina le Thaumaturge",
  "aboutPage.saints.stMina.title": "Saint Patron",
  "aboutPage.saints.stMina.desc": "Martyr égyptien et faiseur de miracles, l'un des saints les plus aimés. Notre église porte son nom et a été établie le jour de sa fête.",
  "aboutPage.saints.stMina.feast": "24 Novembre",
  "aboutPage.saints.popeCyril.name": "Pape Cyrille VI",
  "aboutPage.saints.popeCyril.title": "Saint Patron",
  "aboutPage.saints.popeCyril.desc": "Le 116e Pape d'Alexandrie, connu pour sa sainteté, ses miracles et sa profonde spiritualité. Notre église porte son nom.",
  "aboutPage.saints.popeCyril.feast": "9 Mars",

  // About Page Leadership
  "aboutPage.leadership.popeTawadros.name": "S.S. le Pape Tawadros II",
  "aboutPage.leadership.popeTawadros.title": "Pape d'Alexandrie",
  "aboutPage.leadership.popeTawadros.desc": "Le 118e Pape d'Alexandrie et Patriarche du Siège de Saint Marc. Sa Sainteté dirige l'Église Copte Orthodoxe mondiale avec sagesse et grâce.",
  "aboutPage.leadership.bishopBoulos.name": "S.G. l'Évêque Boulos",
  "aboutPage.leadership.bishopBoulos.title": "Évêque d'Ottawa, Montréal et l'Est du Canada",
  "aboutPage.leadership.bishopBoulos.desc": "Sa Grâce l'Évêque Boulos el Baramousy a été ordonné en 2019 par le Pape Tawadros II pour superviser le Diocèse d'Ottawa, Montréal et l'Est du Canada.",
  "aboutPage.leadership.frAnthony.name": "P. Anthony Micheal",
  "aboutPage.leadership.frAnthony.title": "Prêtre de Paroisse",
  "aboutPage.leadership.frAnthony.desc": "Le Père Anthony sert comme prêtre dévoué de l'Église Saint Mina et Pape Cyrille VI, guidant notre communauté avec amour depuis son envoi par le Pape Tawadros II en 2016.",

  // Services Page
  "servicesPage.title": "Services de Culte",
  "servicesPage.subtitle": "Rejoignez-nous dans le culte et la croissance spirituelle",
  "servicesPage.whatWeOffer": "Ce Que Nous Offrons",
  "servicesPage.ministriesPrograms": "Ministères et Programmes",
  "servicesPage.ministriesDesc": "Notre église offre une variété de services et ministères pour vous aider à grandir dans la foi et servir les autres.",
  "servicesPage.getInvolved": "Impliquez-vous",
  "servicesPage.getInvolvedDesc": "Nous vous invitons à rejoindre l'un de nos ministères et à utiliser vos talents pour servir l'église et la communauté.",
  "servicesPage.joinFormTitle": "Rejoignez-nous ou Demandez Plus d'Informations",
  "servicesPage.joinFormDesc": "Sélectionnez un service et nous vous répondrons.",
  "servicesPage.fullNameLabel": "Nom Complet",
  "servicesPage.yourName": "Votre nom",
  "servicesPage.emailLabel": "Courriel",
  "servicesPage.youExample": "vous@exemple.com",
  "servicesPage.phoneLabel": "Téléphone",
  "servicesPage.serviceInterested": "Service qui m'intéresse",
  "servicesPage.selectService": "Sélectionnez un service...",
  "servicesPage.messageOpt": "Message",
  "servicesPage.messageOptDesc": "Des questions ou détails...",
  "servicesPage.maxChars": "Maximum 500 caractères",
  "servicesPage.submitRequest": "Envoyer la Demande",

  // ── Services Detail Data ──
  "services.bibleStudy.title": "Étude Biblique",
  "services.bibleStudy.schedule": "Chaque Samedi, 17h00",
  "services.bibleStudy.location": "Salles de Classe de l'Église",
  "services.bibleStudy.desc": "Approfondissez votre compréhension des Saintes Écritures à travers nos sessions d'étude biblique hebdomadaires. Dirigées par notre clergé et des enseignants expérimentés, ces rencontres explorent l'Ancien et le Nouveau Testament.",
  "services.bibleStudy.feature1": "Étude verset par verset",
  "services.bibleStudy.feature2": "Discussions de groupe",
  "services.bibleStudy.feature3": "Sessions de questions-réponses",
  "services.bibleStudy.feature4": "Matériel d'étude fourni",

  "services.hymnsClass.title": "Cours d'Hymnes",
  "services.hymnsClass.schedule": "Chaque Samedi, 19h00",
  "services.hymnsClass.location": "Salles de Classe de l'Église",
  "services.hymnsClass.desc": "Apprenez les magnifiques et anciennes hymnes coptes transmises de génération en génération. Notre cours d'hymnes enseigne les mélodies traditionnelles, la prononciation et la signification spirituelle de chaque hymne.",
  "services.hymnsClass.feature1": "Instruction en langue copte",
  "services.hymnsClass.feature2": "Mélodies traditionnelles",
  "services.hymnsClass.feature3": "Histoire et sens des hymnes",
  "services.hymnsClass.feature4": "Tous les niveaux bienvenus",

  "services.sundaySchool.title": "École du Dimanche",
  "services.sundaySchool.schedule": "Chaque Dimanche, 12h30",
  "services.sundaySchool.location": "Salles de Classe de l'Église",
  "services.sundaySchool.desc": "Notre programme d'École du Dimanche offre une éducation à la foi pour les enfants et les jeunes de tous âges. À travers des leçons engageantes, les jeunes apprennent la Bible et les traditions coptes.",
  "services.sundaySchool.feature1": "Classes par âge",
  "services.sundaySchool.feature2": "Leçons interactives",
  "services.sundaySchool.feature3": "Activités d'art et d'artisanat",
  "services.sundaySchool.feature4": "Compétitions annuelles",

  "services.youthMeeting.title": "Rencontre des Jeunes",
  "services.youthMeeting.schedule": "Chaque Vendredi, 20h30",
  "services.youthMeeting.location": "Sous-sol de l'Église",
  "services.youthMeeting.desc": "Une communauté dynamique pour les jeunes adultes pour grandir ensemble dans la foi. Notre Rencontre des Jeunes combine discussions spirituelles, activités de communion fraternelle et opportunités de service.",
  "services.youthMeeting.feature1": "Discussions spirituelles",
  "services.youthMeeting.feature2": "Activités sociales",
  "services.youthMeeting.feature3": "Projets de service",
  "services.youthMeeting.feature4": "Retraites et voyages",

  "services.familyMeeting.title": "Rencontre Familiale",
  "services.familyMeeting.schedule": "Chaque Vendredi, 20h30",
  "services.familyMeeting.location": "Couloir du Pape Cyrille",
  "services.familyMeeting.desc": "Renforcez les liens familiaux par la foi avec notre Rencontre Familiale mensuelle. Parents et enfants se réunissent pour la guidance spirituelle et des activités familiales.",
  "services.familyMeeting.feature1": "Culte familial",
  "services.familyMeeting.feature2": "Guidance parentale",
  "services.familyMeeting.feature3": "Activités pour enfants",
  "services.familyMeeting.feature4": "Dîner de communion fraternelle",

  "services.seniorsMeeting.title": "Rencontre des Aînés",
  "services.seniorsMeeting.schedule": "Chaque Jeudi, 11h00",
  "services.seniorsMeeting.location": "Salle Paroissiale",
  "services.seniorsMeeting.desc": "Un rassemblement précieux pour nos membres aînés pour profiter de la communion fraternelle et du soutien communautaire. La Rencontre des Aînés inclut prière, discussions sur la santé et activités sociales.",
  "services.seniorsMeeting.feature1": "Prière et dévotion",
  "services.seniorsMeeting.feature2": "Séminaires de santé",
  "services.seniorsMeeting.feature3": "Activités sociales",
  "services.seniorsMeeting.feature4": "Déjeuner fourni",

  "services.churchChoirs.title": "Chorales de l'Église",
  "services.churchChoirs.schedule": "Répétition : Samedis, 16h00",
  "services.churchChoirs.location": "Sanctuaire de l'Église",
  "services.churchChoirs.desc": "Nos Chorales dirigent la congrégation dans le culte sacré à travers de magnifiques hymnes et réponses coptes. Nous avons des chorales pour différents groupes d'âge.",
  "services.churchChoirs.feature1": "Chorale adulte",
  "services.churchChoirs.feature2": "Chorale jeunesse",
  "services.churchChoirs.feature3": "Chorale d'enfants",
  "services.churchChoirs.feature4": "Occasions spéciales",

  "services.theatreService.title": "Service Théâtral",
  "services.theatreService.schedule": "Représentations Saisonnières",
  "services.theatreService.location": "Salle de l'Église",
  "services.theatreService.desc": "Notre Ministère du Théâtre donne vie aux écritures et aux vies des saints à travers des représentations dramatiques puissantes. Nos membres talentueux utilisent les arts pour inspirer la foi.",
  "services.theatreService.feature1": "Pièces bibliques",
  "services.theatreService.feature2": "Drames de vies de saints",
  "services.theatreService.feature3": "Représentations jeunesse",
  "services.theatreService.feature4": "Productions de fêtes",

  "services.itMedia.title": "Services IT et Médias",
  "services.itMedia.schedule": "Support Continu",
  "services.itMedia.location": "Salle Médias",
  "services.itMedia.desc": "Notre équipe IT et Médias s'assure que notre église reste connectée avec la communauté via la technologie, de la diffusion en direct à la gestion des réseaux sociaux.",
  "services.itMedia.feature1": "Diffusion en direct",
  "services.itMedia.feature2": "Gestion du site web",
  "services.itMedia.feature3": "Réseaux sociaux",
  "services.itMedia.feature4": "Support audio/visuel",

  "services.kitchenServices.title": "Services de Cuisine",
  "services.kitchenServices.schedule": "Dimanches et Événements Spéciaux",
  "services.kitchenServices.location": "Cuisine de l'Église",
  "services.kitchenServices.desc": "Notre équipe des Services de Cuisine prépare des repas pour la communion fraternelle après la liturgie et les événements spéciaux. Ce ministère d'hospitalité rassemble la communauté autour de la table.",
  "services.kitchenServices.feature1": "Repas agape du dimanche",
  "services.kitchenServices.feature2": "Service traiteur d'événements",
  "services.kitchenServices.feature3": "Options de menu de jeûne",
  "services.kitchenServices.feature4": "Opportunités de bénévolat",

  "services.holyBread.title": "Services du Pain Sacré",
  "services.holyBread.schedule": "Samedis, Tôt le Matin",
  "services.holyBread.location": "Salle de Préparation du Pain",
  "services.holyBread.desc": "Le service du Pain Sacré (Korban) est un ministère sacré où des bénévoles préparent le pain utilisé pour la Sainte Communion. Cette tradition ancienne requiert prière, jeûne et dévotion.",
  "services.holyBread.feature1": "Préparation sacrée",
  "services.holyBread.feature2": "Méthodes traditionnelles",
  "services.holyBread.feature3": "Prière et hymnes",
  "services.holyBread.feature4": "Formation disponible",

  "services.cleaningServices.title": "Services de Nettoyage",
  "services.cleaningServices.schedule": "Hebdomadaire et Selon Besoin",
  "services.cleaningServices.location": "Ensemble du Campus de l'Église",
  "services.cleaningServices.desc": "Notre équipe des Services de Nettoyage maintient la beauté et la sainteté de la maison de Dieu. Ces bénévoles dévoués s'assurent que notre église est propre et accueillante.",
  "services.cleaningServices.feature1": "Entretien du sanctuaire",
  "services.cleaningServices.feature2": "Entretien des salles",
  "services.cleaningServices.feature3": "Entretien des terrains",
  "services.cleaningServices.feature4": "Installation/nettoyage d'événements",

  "services.homelessServices.title": "Services aux Sans-Abri",
  "services.homelessServices.schedule": "Action Mensuelle",
  "services.homelessServices.location": "Action Communautaire",
  "services.homelessServices.desc": "Suivant l'appel du Christ à servir les plus petits d'entre nous, notre ministère des Services aux Sans-Abri fournit nourriture, vêtements et soutien aux personnes dans le besoin.",
  "services.homelessServices.feature1": "Distribution de nourriture",
  "services.homelessServices.feature2": "Collectes de vêtements",
  "services.homelessServices.feature3": "Partenariats avec refuges",
  "services.homelessServices.feature4": "Colis de soins",

  "services.libraryService.title": "Service de Bibliothèque",
  "services.libraryService.schedule": "Ouvert les Dimanches et Sur Demande",
  "services.libraryService.location": "Bibliothèque de l'Église",
  "services.libraryService.desc": "Notre Bibliothèque offre une richesse de ressources spirituelles incluant des livres sur la théologie orthodoxe, les vies des saints, l'histoire copte et du matériel multimédia.",
  "services.libraryService.feature1": "Livres théologiques",
  "services.libraryService.feature2": "Section enfants",
  "services.libraryService.feature3": "Ressources audio/vidéo",
  "services.libraryService.feature4": "Matériel d'étude",

  // News Page
  "newsPage.title": "Actualités",
  "newsPage.subtitle": "Restez informés des événements, publications et bulletins de notre communauté",
  "newsPage.articles": "Articles",
  "newsPage.events": "Événements",
  "newsPage.posts": "Publications",
  "newsPage.newsletters": "Bulletins",
  "newsPage.readMore": "Lire Plus",
  "newsPage.monthlyNewsletters": "Bulletins Mensuels",
  "newsPage.newslettersDesc": "Téléchargez nos bulletins mensuels pour rester informés des activités de l'église",
  "newsPage.downloadPDF": "Télécharger PDF",
  "newsPage.newsletter1Title": "Bulletin de Janvier",
  "newsPage.newsletter1Desc": "Bénédictions du nouvel an, événements à venir et mises à jour",
  "newsPage.newsletter2Title": "Bulletin de Décembre",
  "newsPage.newsletter2Desc": "Célébrations de Noël, bilan de l'année et gratitude",
  "newsPage.newsletter3Title": "Bulletin de Novembre",
  "newsPage.newsletter3Desc": "Réflexions d'action de grâce et moments forts",
  "newsPage.newsletter4Title": "Bulletin d'Octobre",
  "newsPage.newsletter4Desc": "Activités d'automne et opportunités de ministère",
  "newsPage.subscribeNewsletter": "S'abonner à Notre Bulletin",
  "newsPage.subscribeDesc": "Recevez des mises à jour mensuelles directement dans votre boîte de réception",
  "newsPage.emailPlaceholder": "Entrez votre courriel",
  "newsPage.subscribe": "S'abonner",
  "newsPage.viewAllOnInstagram": "Voir Toutes les Publications sur Instagram",
  "newsPage.seasonalPosts": "Articles Saisonniers",
  "newsPage.seasonalPostsDesc": "Réflexions approfondies sur les saisons et célébrations de l'année liturgique copte orthodoxe",
  "newsPage.socialMedia": "Réseaux Sociaux",
  "newsPage.socialMediaDesc": "Restez connectés avec nos derniers moments, réflexions et moments forts de la communauté.",
  "newsPage.monthlyUpdates": "Mises à Jour Mensuelles",
  "newsPage.currentlyObserving": "Observance Actuelle",
  "newsPage.currentSeason": "Saison Actuelle",
  "newsPage.nextFeast": "Prochaine Fête",
  "newsPage.nextFast": "Prochain Jeûne",
  "newsPage.days": "Jours",
  "newsPage.now": "Maintenant",
  "newsPage.fastingObserved": "Jeûne observé",
  "newsPage.backToArticles": "Retour aux Articles",
  "newsPage.fastingGuidelines": "Directives de Jeûne",
  "newsPage.exploreCalendar": "Explorez notre calendrier complet — services hebdomadaires, jours de fête, périodes de jeûne et événements spéciaux tout au long de l'année liturgique copte.",

  // Calendar Page
  "calendarPage.title": "Calendrier",
  "calendarPage.subtitle": "Jours de fête, périodes de jeûne et services hebdomadaires",
  "calendarPage.weeklySchedule": "Horaire Hebdomadaire",
  "calendarPage.thisWeekServices": "Services de Cette Semaine",
  "calendarPage.weeklyScheduleDesc": "Restez connectés avec nos services hebdomadaires, jours de fête et rassemblements communautaires",
  "calendarPage.liturgicalYear": "Année Liturgique",
  "calendarPage.feastDaysFasting": "Jours de Fête et Jeûnes",
  "calendarPage.liturgicalYearDesc": "L'Église Copte Orthodoxe suit un ancien calendrier liturgique riche en fêtes, commémorations et périodes de jeûne observées depuis plus de 2000 ans.",
  "calendarPage.tab.all": "Tout",
  "calendarPage.tab.major": "7 Fêtes Majeures",
  "calendarPage.tab.minor": "7 Fêtes Mineures",
  "calendarPage.tab.fast": "Périodes de Jeûne",
  "calendarPage.stats.majorFeasts": "Fêtes Majeures du Seigneur",
  "calendarPage.stats.minorFeasts": "Fêtes Mineures du Seigneur",
  "calendarPage.stats.fastingDays": "Jours de Jeûne par An",
  "calendarPage.majorInfoTitle": "Les 7 Fêtes Majeures",
  "calendarPage.majorInfoDesc": "sont les célébrations les plus importantes de l'année liturgique copte. Elles commémorent les événements clés de la vie du Christ et sont précédées de jeûne et de préparation spéciaux.",
  "calendarPage.minorInfoTitle": "Les 7 Fêtes Mineures",
  "calendarPage.minorInfoDesc": "complètent les Fêtes Majeures en commémorant d'autres événements significatifs de la vie du Christ et de la Vierge Marie. Elles enrichissent la vie spirituelle des fidèles tout au long de l'année.",
  "calendarPage.fastInfoTitle": "Le Jeûne dans l'Église Copte",
  "calendarPage.fastInfoDesc": "est l'une des plus anciennes pratiques chrétiennes. L'Église Copte Orthodoxe observe plus de 210 jours de jeûne par an. Le jeûne implique l'abstinence de tous les produits animaux.",
  "calendarPage.category.major": "Fête Majeure",
  "calendarPage.category.minor": "Fête Mineure",
  "calendarPage.category.fast": "Période de Jeûne",
  "calendarPage.spiritualSignificance": "Signification Spirituelle",
  "calendarPage.stayUpdated": "Restez Informés",
  "calendarPage.stayUpdatedDesc": "Suivez les dernières nouvelles, événements, sermons et mises à jour de la communauté.",
  "calendarPage.goToNews": "Aller aux Actualités",
  "calendarPage.viewFullCalendar": "Voir le Calendrier Complet",
  "calendarPage.goToCalendar": "Aller au Calendrier",
  "calendarPage.aboutCopticCalendar": "À Propos du Calendrier Copte",
  "calendarPage.calendarInfo": "Le calendrier copte commence le 11 septembre (Nayrouz) et compte 13 mois. Les fêtes mobiles comme Pâques suivent le calendrier julien. Les dates indiquées sont dans le calendrier grégorien.",

  // Contact Page
  "contactPage.title": "Contactez-nous",
  "contactPage.subtitle": "Nous serions ravis de vous entendre",
  "contactPage.getInTouch": "Entrer en Contact",
  "contactPage.address": "Adresse",
  "contactPage.phone": "Téléphone",
  "contactPage.email": "Courriel",
  "contactPage.findUs": "Nous Trouver",
  "contactPage.name": "Nom",
  "contactPage.namePlaceholder": "Votre nom complet",
  "contactPage.emailPlaceholder": "votre.courriel@exemple.com",
  "contactPage.phonePlaceholder": "(514) 123-4567",
  "contactPage.message": "Message",
  "contactPage.messagePlaceholder": "Comment pouvons-nous vous aider?",
  "contactPage.sendMessage": "Envoyer le Message",
  "contactPage.sending": "Envoi en cours...",
  "contactPage.thankYou": "Merci! Nous vous répondrons bientôt.",
  "contactPage.privacyNote": "Nous respectons votre vie privée et ne partagerons jamais vos informations.",
  "contactPage.leadership": "Direction",
  "contactPage.resourcesCTA": "Explorez notre collection de formulaires, applications numériques, réponses aux questions courantes, matériel de bibliothèque et ressources de marque officielles.",
  "contactPage.goToResources": "Aller aux Ressources",

  // Donate Page
  "donatePage.title": "Soutenez Notre Mission",
  "donatePage.subtitle": "Votre générosité fait une différence",
  "donatePage.supportMission": "Soutenez Notre",
  "donatePage.mission": "Mission",
  "donatePage.donateDesc": "Vos contributions nous aident à poursuivre notre ministère et à répandre l'amour de Dieu.",
  "donatePage.taxDeductible": "Tous les dons sont déductibles d'impôt",
  "donatePage.giveNow": "Donner Maintenant",
  "donatePage.giveMonthly": "Donner Mensuellement",
  "donatePage.recurringGift": "Configurer un Don Récurrent",
  "donatePage.oneTime": "Unique",
  "donatePage.monthly": "Mensuel",
  "donatePage.monthlyGift": "Choisir un Montant Mensuel",
  "donatePage.whyMonthly": "Pourquoi donner mensuellement?",
  "donatePage.monthlyImpact": "Les dons mensuels offrent un soutien stable qui nous aide à maintenir nos ministères toute l'année.",
  "donatePage.securePayment": "Paiement Sécurisé",
  "donatePage.sslEncrypted": "Cryptage SSL",
  "donatePage.taxReceipt": "Reçu Fiscal Fourni",
  "donatePage.ministryPrograms": "Programmes Ministériels",
  "donatePage.ministryProgramsDesc": "Soutenir les services de culte et programmes jeunesse",
  "donatePage.communityOutreach": "Action Communautaire",
  "donatePage.communityOutreachDesc": "Aider les personnes dans le besoin",
  "donatePage.missionWork": "Travail Missionnaire",
  "donatePage.missionWorkDesc": "Répandre l'évangile à travers le monde",
  "donatePage.otherWaysToGive": "Autres Façons de Donner",
  "donatePage.giveWithPayPal": "PayPal",
  "donatePage.giveWithPayPalDesc": "Faites un don en ligne en toute sécurité avec PayPal.",
  "donatePage.openPayPal": "Faire un don avec PayPal",
  "donatePage.registeredCharity": "Organisme de Bienfaisance Enregistré",
  "donatePage.charityNumber": "Reçus officiels fournis à des fins fiscales",
  "donatePage.taxReceiptsWillBeIssued": "Des reçus fiscaux seront émis pour tous les dons",
  "donatePage.interacTransfer": "Virement Interac",
  "donatePage.interacDesc": "Envoyez votre virement depuis votre compte bancaire canadien.",
  "donatePage.interacEmail": "Envoyer à",
  "donatePage.interacQuestion": "Question de Sécurité",
  "donatePage.interacAnswer": "Réponse",
  "donatePage.interacTaxNote": "Incluez nom, adresse, téléphone et courriel pour le reçu fiscal.",
  "donatePage.mailCheck": "Envoyer un Chèque",
  "donatePage.mailCheckDesc": "Chèques à l'ordre de \"Église Saint Mina & Pape Cyrille VI\".",
  "donatePage.inKindDonations": "Dons en Nature",
  "donatePage.inKindDonationsDesc": "Nous acceptons les dons de biens et services.",
  "donatePage.paypalSecure": "Paiement sécurisé via PayPal",
  "donatePage.close": "Fermer",
  "donatePage.legacyGiving": "Don Testamentaire",
  "donatePage.legacyGivingDesc": "Incluez notre église dans votre planification successorale.",
  "donatePage.bibleVerse": "Que chacun donne comme il l'a résolu en son cœur, sans tristesse ni contrainte; car Dieu aime celui qui donne avec joie.",
  "donatePage.bibleVerseRef": "2 Corinthiens 9:7",
  "donatePage.selectAmount": "Choisir un Montant",
  "donatePage.customAmount": "Montant Personnalisé",
  "donatePage.enterAmount": "Entrez le montant",

  // Sermons Page
  "sermonsPage.title": "Sermons",
  "sermonsPage.subtitle": "Messages inspirants de notre clergé",
  "sermons.loading": "Chargement des sermons...",
  "sermons.viewAll": "Voir Tout",
  "sermons.watchOnYouTube": "Regarder sur YouTube",
  "sermons.noVideos": "Aucune vidéo disponible",

  // Calendar Feasts Data
  "feast.nativity.name": "Nativité du Christ (Noël)",
  "feast.nativity.date": "7 janvier (29 Kiahk)",
  "feast.nativity.desc": "La célébration de la naissance de Notre Seigneur Jésus-Christ à Bethléem par la Vierge Marie.",
  "feast.nativity.significance": "L'une des fêtes les plus joyeuses de l'année. Précédée du jeûne de l'Avent de 43 jours, la Nativité marque l'Incarnation de Dieu.",
  "feast.theophany.name": "Théophanie (Épiphanie)",
  "feast.theophany.date": "19 janvier (11 Tobi)",
  "feast.theophany.desc": "Commémore le baptême de Jésus-Christ dans le Jourdain par saint Jean-Baptiste.",
  "feast.theophany.significance": "La Sainte Trinité s'est pleinement révélée. Les églises coptes bénissent l'eau ce jour-là.",
  "feast.annunciation.name": "Annonciation",
  "feast.annunciation.date": "7 avril (29 Baramhat)",
  "feast.annunciation.desc": "L'archange Gabriel annonce à la Vierge Marie qu'elle concevra et enfantera le Fils de Dieu.",
  "feast.annunciation.significance": "Cette fête marque le moment de l'Incarnation — quand la Vierge Marie dit \"Qu'il me soit fait selon ta parole\". Célébrée exactement neuf mois avant la Nativité.",
  "feast.palmSunday.name": "Dimanche des Rameaux",
  "feast.palmSunday.date": "Variable — dimanche avant Pâques",
  "feast.palmSunday.desc": "L'entrée triomphale du Christ à Jérusalem, accueilli par des foules agitant des palmes.",
  "feast.palmSunday.significance": "Le Dimanche des Rameaux ouvre la Semaine Sainte, la semaine la plus sacrée de l'année copte. Les palmes sont bénies et distribuées.",
  "feast.resurrection.name": "Résurrection (Pâques / Saint Pascha)",
  "feast.resurrection.date": "Variable — suit le calendrier julien",
  "feast.resurrection.desc": "La glorieuse résurrection de Notre Seigneur Jésus-Christ d'entre les morts le troisième jour.",
  "feast.resurrection.significance": "La fête la plus grande et la plus importante de toute l'année chrétienne. L'Église éclate de joie: \"Le Christ est ressuscité!\"",
  "feast.ascension.name": "Ascension du Christ",
  "feast.ascension.date": "40 jours après Pâques (jeudi)",
  "feast.ascension.desc": "Le Christ monte corporellement au ciel quarante jours après Sa Résurrection.",
  "feast.ascension.significance": "L'Ascension confirme que l'humanité glorifiée du Christ siège maintenant à la droite du Père.",
  "feast.pentecost.name": "Pentecôte (Descente du Saint-Esprit)",
  "feast.pentecost.date": "50 jours après Pâques (dimanche)",
  "feast.pentecost.desc": "Le Saint-Esprit descend sur les Apôtres dans le Cénacle sous forme de langues de feu.",
  "feast.pentecost.significance": "La Pentecôte est considérée comme l'anniversaire de l'Église. Les disciples reçoivent le don du Saint-Esprit.",
  "feast.circumcision.name": "Circoncision du Christ",
  "feast.circumcision.date": "14 janvier (6 Tobi)",
  "feast.circumcision.desc": "Commémore la circoncision du bébé Jésus le huitième jour après Sa naissance.",
  "feast.circumcision.significance": "Le Christ s'est soumis à la Loi de Moïse pour la remplir en notre nom.",
  "feast.presentation.name": "Présentation au Temple",
  "feast.presentation.date": "15 février (8 Amshir)",
  "feast.presentation.desc": "La présentation du bébé Jésus au Temple de Jérusalem, quarante jours après Sa naissance.",
  "feast.presentation.significance": "Simoéon et Anne ont reconnu l'enfant Christ comme le Messie.",
  "feast.holyFamily.name": "Entrée de la Sainte Famille en Égypte",
  "feast.holyFamily.date": "1er juin (24 Bashans)",
  "feast.holyFamily.desc": "Commémore la fuite de la Sainte Famille en Égypte pour échapper au roi Hérode.",
  "feast.holyFamily.significance": "L'Égypte a une place unique dans l'identité copte: la Sainte Famille a béni le sol égyptien par sa présence.",
  "feast.transfiguration.name": "Transfiguration du Christ",
  "feast.transfiguration.date": "19 août (13 Misra)",
  "feast.transfiguration.desc": "Le Christ est transfiguré sur le Mont Tabor, révélant Sa gloire divine à Pierre, Jacques et Jean.",
  "feast.transfiguration.significance": "La Transfiguration donne un aperçu de la nature divine du Christ. Moïse et Élie apparaissent à ses côtés.",
  "feast.dormition.name": "Dormition de la Vierge Marie",
  "feast.dormition.date": "22 août (16 Misra)",
  "feast.dormition.desc": "Commémore le départ et l'assomption de la Théotocos (Mère de Dieu), la Vierge Marie.",
  "feast.dormition.significance": "Précédé du jeûne de Sainte Marie de 15 jours, cette fête honore le passage de la Vierge Marie.",
  "feast.crossExaltation.name": "Fête de la Sainte Croix",
  "feast.crossExaltation.date": "27 septembre (17 Tout)",
  "feast.crossExaltation.desc": "Commémore la découverte de la Vraie Croix par l'impératrice Hélène en 326 apr. J.-C.",
  "feast.crossExaltation.significance": "La Croix est le symbole central du salut.",
  "feast.nayrouz.name": "Nouvel An Copte (Nayrouz)",
  "feast.nayrouz.date": "11 septembre (1 Tout)",
  "feast.nayrouz.desc": "Le premier jour de l'année du calendrier copte, aussi connu comme la Fête des Martyrs.",
  "feast.nayrouz.significance": "Nayrouz honore les milliers de martyrs chrétiens égyptiens. Les dattes rouges et les roses rouges symbolisent le sang des martyrs.",
  "feast.greatLent.name": "Grand Carême (Saint Jeûne de 55 Jours)",
  "feast.greatLent.date": "55 jours avant Pâques",
  "feast.greatLent.desc": "La période de jeûne la plus sainte de l'année copte, préparant les fidèles pour le Saint Pascha.",
  "feast.greatLent.significance": "Le Grand Carême comprend 40 jours plus la Semaine Sainte. Un temps de prière intense, de jeûne et de renouveau spirituel.",
  "feast.adventFast.name": "Jeûne de l'Avent (Jeûne de Noël)",
  "feast.adventFast.date": "25 novembre – 6 janvier (43 jours)",
  "feast.adventFast.desc": "Un jeûne de 43 jours préparant les fidèles à la Nativité du Christ.",
  "feast.adventFast.significance": "Un temps de préparation spirituelle et de réflexion sur l'Incarnation.",
  "feast.apostlesFast.name": "Jeûne des Apôtres",
  "feast.apostlesFast.date": "Après la Pentecôte — durée variable",
  "feast.apostlesFast.desc": "Un jeûne en l'honneur des Saints Apôtres, commençant le lundi après la Pentecôte.",
  "feast.apostlesFast.significance": "Ce jeûne commémore le jeûne des Apôtres après avoir reçu le Saint-Esprit. Se termine le 12 juillet.",
  "feast.stMaryFast.name": "Jeûne de Sainte Marie",
  "feast.stMaryFast.date": "7–21 août (15 jours)",
  "feast.stMaryFast.desc": "Un jeûne de 15 jours en l'honneur de la Vierge Marie, précédant sa fête de l'Assomption.",
  "feast.stMaryFast.significance": "Ce jeûne exprime l'amour profond de l'Église pour la Vierge Marie. Se conclut le 22 août.",
  "feast.nineveh.name": "Jeûne de Ninive",
  "feast.nineveh.date": "3 jours — lundi au mercredi, 3 semaines avant le Grand Carême",
  "feast.nineveh.desc": "Un jeûne de trois jours commémorant le repentir des habitants de Ninive.",
  "feast.nineveh.significance": "Ce jeûne nous rappelle la miséricorde de Dieu et la puissance du repentir.",
  "feast.wedFri.name": "Jeûne Hebdomadaire Mercredi et Vendredi",
  "feast.wedFri.date": "Chaque mercredi et vendredi tout au long de l'année",
  "feast.wedFri.desc": "L'Église Copte jeûne chaque mercredi et vendredi tout au long de l'année.",
  "feast.wedFri.significance": "Le mercredi commémore la trahison du Christ. Le vendredi commémore la Crucifixion. Observé en s'abstenant des produits animaux jusqu'à la neuvième heure.",

  // Resources Page
  "resourcesPage.title": "Ressources",
  "resourcesPage.subtitle": "Formulaires, bibliothèques et outils pour notre communauté",
  "resourcesPage.quickAccess": "Accès Rapide",
  "resourcesPage.churchForms": "Formulaires de l'Église",
  "resourcesPage.formsDesc": "Accédez aux formulaires officiels pour les sacrements, événements et adhésion",
  "resourcesPage.membershipForm": "Formulaire d'Adhésion",
  "resourcesPage.membershipFormDesc": "Rejoignez officiellement notre communauté paroissiale",
  "resourcesPage.baptismForm": "Formulaire de Baptême",
  "resourcesPage.baptismFormDesc": "Demandez le sacrement du Saint Baptême",
  "resourcesPage.engagementForm": "Formulaire de Fiançailles",
  "resourcesPage.engagementFormDesc": "Enregistrez votre cérémonie de fiançailles",
  "resourcesPage.weddingForm": "Formulaire de Mariage",
  "resourcesPage.weddingFormDesc": "Planifiez et enregistrez votre cérémonie de mariage",
  "resourcesPage.funeralForm": "Formulaire de Funérailles",
  "resourcesPage.funeralFormDesc": "Organisez les services funéraires et commémoratifs",
  "resourcesPage.eventBooking": "Réservation d'Événement",
  "resourcesPage.eventBookingDesc": "Réservez les salles et espaces de l'église pour vos événements",
  "resourcesPage.accessForm": "Accéder au Formulaire",
  "resourcesPage.dioceseService": "Service du Diocèse",
  "resourcesPage.copticAnswersTitle": "Réponses Coptes Orthodoxes",
  "resourcesPage.copticAnswersDesc": "Une ressource complète du Diocèse d'Ottawa, Montréal et l'Est du Canada fournissant des réponses aux questions courantes sur la foi copte orthodoxe.",
  "resourcesPage.faithQuestions": "Questions de Foi",
  "resourcesPage.faithQuestionsDesc": "Obtenez des réponses claires aux questions courantes sur les croyances coptes orthodoxes",
  "resourcesPage.theologicalTopics": "Sujets Théologiques",
  "resourcesPage.theologicalTopicsDesc": "Explorez des sujets théologiques profonds expliqués par notre clergé",
  "resourcesPage.videoResources": "Ressources Vidéo",
  "resourcesPage.videoResourcesDesc": "Regardez des vidéos éducatives sur la foi et les traditions coptes",
  "resourcesPage.visitCopticAnswers": "Visiter Réponses Coptes Orthodoxes",
  "resourcesPage.learnGrow": "Apprendre et Grandir",
  "resourcesPage.librariesTitle": "Bibliothèques Spirituelles",
  "resourcesPage.librariesDesc": "Explorez notre collection de livres, hymnes et matériels d'étude",
  "resourcesPage.popeShenoudaBooks": "Livres du Pape Shenouda III",
  "resourcesPage.popeShenoudaBooksDesc": "Écrits spirituels et enseignements du Pape Shenouda III",
  "resourcesPage.releaseOfSpirit": "La Libération de l'Esprit",
  "resourcesPage.lifeOfFaith": "Vie de Repentance et de Pureté",
  "resourcesPage.contemplations": "Contemplations sur les Psaumes",
  "resourcesPage.wordsOfBenefit": "Paroles de Bénéfice Spirituel",
  "resourcesPage.hymnalResources": "Ressources d'Hymnologie",
  "resourcesPage.hymnalResourcesDesc": "Livres d'hymnes coptes et ressources musicales liturgiques",
  "resourcesPage.copticHymnsBook": "Livre d'Hymnes Coptes",
  "resourcesPage.tasbehaLyrics": "Paroles de Tasbeha",
  "resourcesPage.liturgyResponses": "Liturgie de Saint Basile",
  "resourcesPage.seasonalHymns": "Hymnes Saisonniers",
  "resourcesPage.bibleStudyMaterials": "Matériels d'Étude Biblique",
  "resourcesPage.bibleStudyMaterialsDesc": "Guides d'étude et commentaires pour l'étude des Écritures",
  "resourcesPage.oldTestament": "Étude de l'Ancien Testament",
  "resourcesPage.newTestament": "Étude du Nouveau Testament",
  "resourcesPage.psalmsCommentary": "Commentaire des Psaumes",
  "resourcesPage.churchFathers": "Pères de l'Église",
  "resourcesPage.sundaySchoolCurriculum": "Programme de l'École du Dimanche",
  "resourcesPage.sundaySchoolCurriculumDesc": "Matériels de formation à la foi adaptés à chaque âge",
  "resourcesPage.preKMaterials": "Matériels Préscolaires",
  "resourcesPage.elementaryLessons": "Leçons Élémentaires",
  "resourcesPage.youthStudies": "Études Jeunesse",
  "resourcesPage.adultFormation": "Formation des Adultes",
  "resourcesPage.brandAssets": "Ressources de Marque",
  "resourcesPage.logoAndFonts": "Logo et Polices",
  "resourcesPage.logoAndFontsDesc": "Logos officiels de l'église et polices coptes pour les publications",
  "resourcesPage.churchLogo": "Logo de l'Église",
  "resourcesPage.fullColorLogo": "Logo Couleur Complète",
  "resourcesPage.primaryUse": "Usage principal — fonds clairs",
  "resourcesPage.downloadPNG": "Télécharger PNG",
  "resourcesPage.whiteLogo": "Logo Blanc",
  "resourcesPage.darkBackgrounds": "Pour fonds sombres",
  "resourcesPage.monochromeLogo": "Logo Monochrome",
  "resourcesPage.printMaterials": "Matériels d'impression",
  "resourcesPage.iconOnly": "Icône Seule",
  "resourcesPage.outlineLightLogo": "Contour Clair",
  "resourcesPage.outlineLightDesc": "Pour fonds sombres",
  "resourcesPage.outlineDarkLogo": "Contour Sombre",
  "resourcesPage.outlineDarkDesc": "Pour fonds clairs",
  "resourcesPage.copticFonts": "Polices Coptes",
  "resourcesPage.copticFontsTitle": "Pack de Polices Coptes Officiel",
  "resourcesPage.copticFontsSubtitle": "Pour Windows et Mac",
  "resourcesPage.copticFontsDesc": "Téléchargez les polices coptes officielles utilisées dans nos publications liturgiques, ressources de l'École du Dimanche et publications de l'église.",
  "resourcesPage.downloadFontPack": "Télécharger le Pack de Polices (.zip)",
  "resourcesPage.installationGuide": "Guide d'Installation",
  "resourcesPage.installationGuideTitle": "Comment Installer les Polices Coptes",
  "resourcesPage.installationGuideWindows": "Windows",
  "resourcesPage.installationGuideMac": "Mac",
  "resourcesPage.installationGuideStep1": "Téléchargez le fichier ZIP du pack de polices",
  "resourcesPage.installationGuideStep2": "Extrayez/décompressez le fichier téléchargé",
  "resourcesPage.installationGuideStep3Win": "Clic droit sur chaque fichier .ttf ou .otf → Installer",
  "resourcesPage.installationGuideStep3Mac": "Double-cliquez sur chaque fichier .ttf ou .otf → Installer la police",
  "resourcesPage.installationGuideStep4": "Redémarrez votre application (Word, etc.) pour utiliser les polices",
  "resourcesPage.sampleText": "Texte copte exemple — Le Christ est ressuscité",
  "resourcesPage.fontsIncluded": "Polices incluses dans ce pack:",
  "resourcesPage.usageGuidelines": "Directives d'Utilisation",
  "resourcesPage.usageGuidelinesDesc": "Ces ressources sont pour usage officiel de l'église uniquement. Veuillez maintenir l'intégrité des logos et utiliser les polices approuvées dans toutes les publications.",
  "resourcesPage.needHelp": "Besoin d'Aide?",
  "resourcesPage.needHelpDesc": "Si vous avez des questions sur les formulaires, ressources ou avez besoin d'assistance, notre équipe est là pour vous aider.",

  // Language
  "language": "Langue",

  // Weekly Calendar Component
  "weeklyCalendar.servicesEvents": "Calendrier des Services et Événements",
  "weeklyCalendar.subscribe": "S'abonner",
  "weeklyCalendar.googleCalendar": "Google Calendar",
  "weeklyCalendar.today": "Aujourd'hui",
  "weeklyCalendar.thisWeekSchedule": "Horaire de Cette Semaine",
  "weeklyCalendar.viewAllWeek": "Voir toute la semaine",
  "weeklyCalendar.loadingEvents": "Chargement des événements...",
  "weeklyCalendar.noEvents": "Aucun événement prévu",
  "weeklyCalendar.events": "événements",
  "weeklyCalendar.liturgy": "Liturgie",
  "weeklyCalendar.feast": "Fête",
  "weeklyCalendar.fast": "Jeûne",
  "weeklyCalendar.meeting": "Réunion",
  "weeklyCalendar.youth": "Jeunesse",
  "weeklyCalendar.subscribeShort": "S'abonner",
  "weeklyCalendar.calendar": "Agenda",
};

export default translations;